export default `float t = 0.0; 
  float s = 12.0;
  float e = 0.0;
  for(int j = 0;j++ < 7; p /= e )
    p = mod( p - 1.0, 2.0 ) - 1.0,
    s /= e =dot( p, p );
  e -= abs( p.y ) + sin( atan( p.x, p.z ) * 6.0 + t * 3.0 ) * 0.2 - 0.3;
  return e / s;
}`